<template>
    <div class="md:max-w-[46.625rem] md:mx-auto ">
        <Title
            :text="$route.meta.pageTitle"
            style-code-page
        />
        <div class="border border-gray-200 rounded-md p-7 md:bg-white">
            <div class="md:max-w-[36rem] md:mx-auto">
                <h4
                    class="text-gray-900 font-normal mb-3"
                    :class="{'sm:text-center':old === ''}"
                >
                    {{ old === ''?'以下為您本次發送動態密碼之行動電話，請確認':'您本次有變更行動電話號碼，請選擇動態密碼要發送至哪一支行動電話？' }}
                </h4>
                <div
                    v-if="old !== ''"
                    class="mb-5 space-y-3"
                >
                    <!-- todo: 之後接地址電話變更時需要在確認畫面 -->
                    <Radio
                        v-model:checked-value="otpMobile"
                        :value="old"
                        :disabled="disabledRadio &&otpMobile!==old"
                        name="mobile"
                    >
                        <span :class="{'text-secondary':otpMobile===old, 'text-gray-100':disabledRadio &&otpMobile!==old}">
                            {{ `原號碼 ${old}` }}
                        </span>
                    </Radio>
                    <Radio
                        v-model:checked-value="otpMobile"
                        :value="lastNumber"
                        :disabled="disabledRadio &&otpMobile!==lastNumber"
                        :text="`新號碼 ${lastNumber}`"
                        name="mobile"
                    >
                        <span :class="{'text-secondary':otpMobile===lastNumber, 'text-gray-100':disabledRadio &&otpMobile!==lastNumber}">
                            {{ `新號碼 ${lastNumber}` }}
                        </span>
                    </Radio>
                    <p class="text-base text-gray-700">
                        若您選擇新行動電話號碼，我們將於申請送出後，以原留存於本公司之市話或行動電話和您確認。
                    </p>
                </div>
                <p
                    v-else
                    class="text-2xl text-secondary font-bold mb-5 text-center"
                >
                    {{ lastNumber }}
                </p>
                <p
                    v-if="verifyErrorTimes"
                    class="text-lg text-warning text-center mb-1"
                >
                    您輸入錯誤次數已{{ verifyErrorTimes }}次
                </p>
                <div
                    v-if="isShowOTPObject"
                    class="flex max-w-[30.9375rem] sm:mx-auto"
                >
                    <input
                        v-model.trim="otpCode"
                        type="text"
                        autocomplete="off"
                        maxlength="6"
                        inputmode="numeric"
                        class="input-base grow w-[55%] rounded-r-none"
                        placeholder="請輸入動態密碼"
                        @input="validateOtpCode"
                    >
                    <button
                        class="p-0 w-[45%] rounded-l-none rounded-r-md text-sm xs:text-base border border-l-0"
                        :class="[counting|| sendTimes===3?'OTP-disabled-btn':'gradient-primary']"
                        :disabled="counting || sendTimes===3"
                        @click="resendOtp"
                    >
                        <vue-countdown
                            v-if="counting"
                            v-slot="{ totalSeconds }"
                            :time="60000"
                            @end="onCountdownEnd"
                        >
                            {{ totalSeconds }}秒後重新發送
                        </vue-countdown>
                        <p v-else>
                            重新發送
                        </p>
                    </button>
                </div>
                <p class="error-msg mx-auto max-w-[30.9375rem] h-4">
                    {{ errorMsg }}
                </p>

                <div class="text-center pt-4">
                    <button
                        v-if="isShowOTPObject && verifyErrorTimes<5"
                        :disabled="isSpin"
                        class="btn gradient-primary rounded-full text-white"
                        @click="goNext"
                    >
                        <SvgIcon
                            v-if="isSpin"
                            icon-name="loading"
                            class="animate-spin h-6 w-6 mr-2"
                        />
                        <span
                            v-if="isSpin"
                            class="text-white"
                        >Loading</span>
                        <span v-else>確定</span>
                    </button>
                    <button
                        v-else
                        :disabled="isSpin || !otpMobile"
                        class="btn gradient-primary rounded-full px-6"
                        :class="{'opacity-70':isSpin}"
                        @click="checkOTP"
                    >
                        <SvgIcon
                            v-if="isSpin"
                            icon-name="loading"
                            class="animate-spin h-6 w-6 mr-2"
                        />
                        <span
                            v-if="isSpin"
                            class="text-white"
                        >
                            Loading
                        </span>
                        <span v-else>
                            發送動態密碼
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <ol class="list-decimal ml-6 my-4 text-gray-900">
            <li class="mb-2 md:mb-1.5">
                系統將於1~2分鐘內傳送動態密碼予您。
            </li>
            <li class="mb-2 md:mb-1.5">
                勿關閉此視窗，請您收到動態密碼後，即刻輸入進行認證。
            </li>
            <li class="mb-2 md:mb-1.5">
                為確保個人資料安全性，此動態密碼自發送後起5分鐘內有效。
            </li>
        </ol>
    </div>
    <Loading :is-loading="isLoading" />
</template>

<script>
import { ref, reactive, toRefs, inject } from 'vue';
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
import Title from '@/components/text/Title.vue';
import Loading from '@/components/Loading.vue';
import { getInfoOTP, postSentOTP, postVerifyOTP, postResentOTP } from '@/apis/OTP';
import { postCheckBDPOTP } from '@/apis/otpCheck';
import { notification } from '@/utils/notification';
import Radio from '@/components/radios/Radio.vue';
import dialogContnet from './dialogContent.js';

export default {
    name: 'OTP',
    components: {
        Title,
        Loading,
        Radio
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const isShowOTPObject = ref(false);
        const counting = ref(false);
        const isLoading = ref(false);
        const isSpin = ref(false);
        const sendTimes = ref(0);
        const verifyErrorTimes = ref(0);
        const errorMsg = ref('');
        const disabledRadio = ref(false);
        const otpCode = ref('');
        const mobileNumber = reactive({
            old: '',
            lastNumber: ''
        });
        const otpMobile = ref('');
        const getData = () => {
            isLoading.value = true;
            getInfoOTP().then((res) => {
                const { beforeMobile, mobile } = res.data;
                mobileNumber.old = beforeMobile;
                mobileNumber.lastNumber = mobile;
                otpMobile.value = beforeMobile === '' && mobile;
            }).finally(() => {
                isLoading.value = false;
            });
        };
        getData();

        /** 打sendOTP之前要打OTP集中檢核otpCheck/checkBDPOTP，result=Ｙ跳視窗 */
        const checkOTP = () => {
            isLoading.value = true;
            postCheckBDPOTP(otpMobile.value).then((res) => {
                if (res.data.result === 'Y') {
                    modalShow(dialogContnet.checkBDPOTP);
                } else {
                    sendOTP();
                }
            }).finally(() => {
                isLoading.value = false;
            });
        };
        /** 發送驗證碼 */
        const sendOTP = () => {
            isSpin.value = true;
            const forceSend = false; // default false

            postSentOTP(forceSend, otpMobile.value);
            setTimeout(() => {
                isShowOTPObject.value = true;
                disabledRadio.value = true;
                counting.value = true;
                isSpin.value = false;
            }, 3000);
        };

        /** 燈箱：交易失敗 */
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        switch (params.id) {
                            case 'otpError5Times': {
                                goHome();
                                break;
                            }
                            case 'checkBDPOTP': {
                                sendOTP();
                                break;
                            }
                        }
                        $vfm.hide('DialogBase');
                    },
                    cancel() {
                        switch (params.id) {
                            case 'checkBDPOTP': {
                                goHome();
                                break;
                            }
                        }
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        /** 回首頁 */
        const goHome = () => {
            router.push({
                name: routeName.HOME
            });
        };
        /** 驗證欄位 */
        const validateOtpCode = () => {
            errorMsg.value = !otpCode.value ? '請輸入動態密碼' : '';
        };

        const goNext = () => {
            if (!otpCode.value) {
                errorMsg.value = '動態密碼未輸入，請確認！';
                return;
            } else {
                errorMsg.value = '';
            }
            isSpin.value = true;
            postVerifyOTP(otpCode.value, otpMobile.value).then(res => {
                const { verify, cancelTransaction, errorTimes } = res.data;
                verifyErrorTimes.value = errorTimes;
                if (verify) {
                    router.push({
                        name: routeName.FINISH
                    });
                } else if (cancelTransaction) {
                    modalShow(dialogContnet.otpError5Times);
                } else {
                    otpCode.value = '';

                    notification({
                        title: '驗證失敗',
                        text: '驗證碼錯誤'
                    });
                }
                setTimeout(() => {
                    isSpin.value = false;
                }, 1000);
            });
        };

        const resendOtp = () => {
            isLoading.value = true;
            errorMsg.value = '';
            otpCode.value = '';
            postResentOTP().then(res => {
                verifyErrorTimes.value = 0;
                sendTimes.value = res.data.resendTimes;
                if (sendTimes.value === 3) {
                    modalShow(dialogContnet.resend3times);
                }
            });
            setTimeout(() => {
                counting.value = true;
                isLoading.value = false;
            }, 3000);
        };

        const onCountdownEnd = () => {
            counting.value = false;
        };

        return {
            isShowOTPObject,
            counting,
            isLoading,
            otpMobile,
            disabledRadio,
            ...toRefs(mobileNumber),
            sendOTP,
            goNext,
            onCountdownEnd,
            resendOtp,
            sendTimes,
            otpCode,
            isSpin,
            verifyErrorTimes,
            checkOTP,
            goHome,
            errorMsg,
            validateOtpCode,
        };
    }
};
</script>

<style lang="scss" scoped>
.OTP-disabled-btn {
    @apply bg-gray-50 border-gray-200 text-gray-200;
}
</style>
